import JsLoadingOverlay from "js-loading-overlay";

export default {
  show(container) {
    JsLoadingOverlay;
    window.JsLoadingOverlay.show({
      overlayBackgroundColor: "#666666",
      overlayOpacity: 0.1,
      spinnerIcon: "line-spin-fade",
      spinnerColor: "#1BC5BD",
      spinnerSize: "1x",
      overlayIDName: "overlay",
      spinnerIDName: "spinner",
      offsetY: 0,
      offsetX: 0,
      lockScroll: false,
      containerID: container,
      spinnerZIndex: 1,
      overlayZIndex: 1,
    });
  },

  hide() {
    window.JsLoadingOverlay.hide();
  },
};
